// src/theme/theme.js
import { createTheme } from "@mui/material/styles";

const baseShadows = [
  "none",
  "0 1px 2px rgba(11,18,32,0.06), 0 1px 1px rgba(11,18,32,0.04)",
  "0 6px 24px rgba(11,18,32,0.10)",
];
export const makeAppTheme = () =>
  createTheme({
    palette: {
      mode: "light",
      primary: { main: "#0B2A4A" },
      secondary: { main: "#4F46E5" },
      info: { main: "#2FE4FF" },
      background: {
        default: "#F7FAFF",
        paper: "#FFFFFF",
      },
      text: {
        primary: "#0B1220",
        secondary: "#425466",
      },
      divider: "rgba(11,18,32,0.10)",
    },
    shape: { borderRadius: 18 },
    typography: {
      fontFamily: ['Inter', "system-ui", "-apple-system", "Segoe UI", "Roboto", "Arial"].join(","),
      h1: { fontWeight: 800, letterSpacing: "-0.03em", fontSize: "clamp(2.2rem, 4vw, 3.4rem)", lineHeight: 1.05 },
      h2: { fontWeight: 800, letterSpacing: "-0.02em", fontSize: "clamp(1.6rem, 2.6vw, 2.2rem)" },
      h3: { fontWeight: 750, letterSpacing: "-0.01em" },
      body1: { fontSize: "1rem", lineHeight: 1.7 },
      button: { textTransform: "none", fontWeight: 700 },
    },
    shadows: [
      baseShadows[0],
      baseShadows[1],
      baseShadows[2],
      ...Array(22).fill("0 0 0 rgba(0,0,0,0)"),
    ],
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 14,
            paddingLeft: 16,
            paddingRight: 16,
            boxShadow: "none",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 18,
            border: "1px solid rgba(11,18,32,0.08)",
          },
        },
      },
      MuiContainer: {
        defaultProps: { maxWidth: "lg" },
      },
      MuiLink: {
        defaultProps: { underline: "none" },
      },
    },
  });
